export default function ChargedIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.58579 1.58579C2.96086 1.21071 3.46957 1 4 1H12C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V15L11 14L8 15L5 14L2 15V3C2 2.46957 2.21071 1.96086 2.58579 1.58579ZM5 5H11V7H5V5ZM5 9H9V11H5V9Z"
        fill="#191A19"
        fillOpacity="0.4"
      />
    </svg>
  );
}
